import { Observable } from 'rxjs';

export interface IMapGeometry {
  // Core viewport positioning
  setCenter(coords: { lng: number; lat: number }): void;
  goToCoordinates(coords: { lng: number; lat: number }, zoom?: number): void;

  // Smooth movement (consolidated from panTo/slewTo)
  panTo(coords: { lng: number; lat: number }, options?: any): Promise<void>;
  panToBounds(bounds: any): void;

  // Bounds management
  getBounds(): any;
  fitBounds(bounds: any): void;

  // Zoom utilities
  setZoom(zoom: number): void;
  getZoom(): number;
  zoomIn(): void;
  zoomOut(): void;
  getMaxZoomAtLatLng?(location: any): Observable<number>; // Google Maps specific
}
